export const environment = {
  production: false,
  supabaseUrl: 'https://6d07edf6.supabase-dev.apps.nordheroes.de',
  supabaseAnonKey: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJzdXBhYmFzZSIsImlhdCI6MTc2OTY4NDg4MCwiZXhwIjo0OTI1MzU4NDgwLCJyb2xlIjoiYW5vbiJ9.F69ugP2jBqmvRBbjo8PrhOyi6ecmvTgxQUWtda_tEyw',
  appUrl: 'https://dev-finder.apps.nordheroes.de',
  supabaseStorageBucket: 'finder-uploads',
  customDomainCnameTarget: 'dev-finder.apps.nordheroes.de',
  supabaseOrganizationLogosBucket: 'organization-logos',
};
